import { OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvService } from '../env.service';
import { ThemeSettingService } from '../services/theme-setting.service';
var ContactUsComponent = /** @class */ (function () {
    function ContactUsComponent(themeSettingService, http, env) {
        this.themeSettingService = themeSettingService;
        this.http = http;
        this.env = env;
        this.isBusy = false;
        this.serviceUrl = this.env.servicePath;
    }
    ContactUsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var themes = this.themeSettingService.getTheme();
        this.loaderConfig = themes;
        this.isBusy = true;
        this.http.get("assets/contact-us/contact-us.html", { responseType: "text" }).subscribe(function (result) {
            _this.contactUs = result;
            _this.isBusy = false;
        }, function (error) {
            _this.isBusy = false;
        });
    };
    return ContactUsComponent;
}());
export { ContactUsComponent };
